var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2c3y1lt1ja"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.819608 0 0 0 0 0.200000 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1222 -102) translate(886 88)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.62 1.278L8 6.662l5.38-5.384c.341-.342.878-.37 1.25-.083l.09.079.003.003c.368.367.368.963 0 1.33L9.336 8l5.389 5.394c.367.367.367.963 0 1.33l-.004.003c-.372.368-.97.366-1.34-.004L8 9.337l-5.38 5.385c-.341.342-.878.37-1.25.083l-.09-.079-.003-.003c-.368-.367-.368-.963 0-1.33l5.387-5.394-5.388-5.392c-.367-.367-.367-.963 0-1.33l.004-.003c.372-.368.97-.366 1.34.004z",
    transform: "translate(336 14)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClose);
export default __webpack_public_path__ + "static/media/icons-close.cc66d33d1af24198b59bb8b0a0466d45.svg";
export { ForwardRef as ReactComponent };